import React from "react";
import { Svg, Path } from "../componet/Footer/style";
import { useScroll } from "../context/UseContextScroll";

function Icon() {
  const { scroll } = useScroll();

  return (
    <Svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      fill="none"
      viewBox="0 0 22 22"
      scroll={scroll}
      phono="true"
    >
      <Path
        stroke="#D6004D"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
        d="M20.888 15.92v3a2 2 0 01-2.18 2 19.791 19.791 0 01-8.63-3.07 19.5 19.5 0 01-6-6 19.79 19.79 0 01-3.07-8.67A2 2 0 012.998 1h3a2 2 0 012 1.72c.127.96.362 1.903.7 2.81a2 2 0 01-.45 2.11l-1.27 1.27a16 16 0 006 6l1.27-1.27a2 2 0 012.11-.45c.907.339 1.85.574 2.81.7a2 2 0 011.72 2.03z"
      ></Path>
    </Svg>
  );
}

export default Icon;
